let state = {
    SIAP_Catalogos_041TipoEstadoCivilId: -1,
    SIAP_Catalogos_007TipoSexo: -1,
    SIAP_Catalogos_025TipoNivelAcademico:{},    
    SIAP_Catalogos_002TipoTitulo: {},    
    SIAP_Catalogos_024TipoDocumento: {},    
    SIAP_Catalogos_039TipoDepartamento: {},    
    SIAP_Catalogos_006PuestoAdministrativo: {},    
    SIAP_Catalogos_028TipoPlaza: {},    
    SIAP_Catalogos_022TipoMovimiento: {},    
    SIAP_Catalogos_003TipoTurno: {},    
    SIAP_Catalogos_027TipoContrato: {},    
    SIAP_Catalogos_008TipoParentesco:{},    
    SIAP_Catalogos_037TipoPlantillaDeNombramiento:{},
    SIAP_Catalogos_043TipoAsunto: {},
    //Hector
    SIAP_DetalleEvaluacion_EvaluacionId: null,
    //Flavio
    SIAP_Catalogos_032TipoEstatusIncidencias:{},
    SIAP_Catalogos_033TipoIncidencias:{},
    SIAP_Catalogos_034TipoSubIncidencias: {}
}
let getters = {
    Get_SIAP_Catalogos_041TipoEstadoCivil: state => {
        return state.SIAP_Catalogos_041TipoEstadoCivilId;
    },
    Get_SIAP_Catalogos_007TipoSexo: state => {
        return state.SIAP_Catalogos_007TipoSexo;
    },
    Get_SIAP_Catalogos_025TipoNivelAcademico: state => {
        return state.SIAP_Catalogos_025TipoNivelAcademico;
    },
    Get_SIAP_Catalogos_002TipoTitulo: state => {
        return state.SIAP_Catalogos_002TipoTitulo;
    },
    Get_SIAP_Catalogos_024TipoDocumento: state => {
        return state.SIAP_Catalogos_024TipoDocumento;
    },
    Get_SIAP_Catalogos_039TipoDepartamento: state => {
        return state.SIAP_Catalogos_039TipoDepartamento;
    },
    Get_SIAP_Catalogos_006PuestoAdministrativo: state => {
        return state.SIAP_Catalogos_006PuestoAdministrativo;
    },
    Get_SIAP_Catalogos_028TipoPlaza: state => {
        return state.SIAP_Catalogos_028TipoPlaza;
    },
    Get_SIAP_Catalogos_022TipoMovimiento: state => {
        return state.SIAP_Catalogos_022TipoMovimiento;
    },
    Get_SIAP_Catalogos_003TipoTurno: state => {
        return state.SIAP_Catalogos_003TipoTurno;
    },
    Get_SIAP_Catalogos_027TipoContrato: state => {
        return state.SIAP_Catalogos_027TipoContrato;
    },
    Get_SIAP_Catalogos_008TipoParentesco: state => {
        return state.SIAP_Catalogos_008TipoParentesco;
    },
    Get_SIAP_Catalogos_032TipoEstatusIncidencias: state=>{
        return state.SIAP_Catalogos_032TipoEstatusIncidencias;
    },
    Get_SIAP_Catalogos_033TipoIncidencias: state=>{
        return state.SIAP_Catalogos_033TipoIncidencias;
    },
    Get_SIAP_Catalogos_034TipoSubIncidencias: state=>{
        return state.SIAP_Catalogos_034TipoSubIncidencias;
    },
    Get_SIAP_Catalogos_037TipoPlnatillaDeNombramiento: state => {
      return state.SIAP_Catalogos_037TipoPlantillaDeNombramiento;
    },
    Get_SIAP_Catalogos_043TipoAsunto: state => {
      return state.SIAP_Catalogos_043TipoAsunto;
    }
}

let mutations = {
    M_SIAP_Catalogos_041TipoEstadoCivil(state, data) {
        state.SIAP_Catalogos_041TipoEstadoCivilId = data;
    },
    M_SIAP_Catalogos_007TipoSexo(state, data) {
        state.SIAP_Catalogos_007TipoSexo = data;
    },
    M_SIAP_Catalogos_025TipoNivelAcademico(state, data) {
        state.SIAP_Catalogos_025TipoNivelAcademico[data.llave] = data.valor;
    },
    M_SIAP_Catalogos_002TipoTitulo(state, data) {
        state.SIAP_Catalogos_002TipoTitulo[data.llave] = data.valor;
    },
    M_SIAP_Catalogos_024TipoDocumento(state, data) {
        state.SIAP_Catalogos_006PuestoAdministrativo[data.llave] = data.valor;
    },
    M_SIAP_Catalogos_039TipoDepartamento(state, data) {
        state.SIAP_Catalogos_039TipoDepartamento[data.llave] = data.valor;
    },
    M_SIAP_Catalogos_006PuestoAdministrativo(state, data) {
        state.SIAP_Catalogos_006PuestoAdministrativo[data.llave] = data.valor;
    },
    M_SIAP_Catalogos_028TipoPlaza(state, data) {
        state.SIAP_Catalogos_028TipoPlaza[data.llave] = data.valor;
    },
    M_SIAP_Catalogos_022TipoMovimiento(state, data) {        
        state.SIAP_Catalogos_022TipoMovimiento[data.llave] = data.valor;
    },
    M_SIAP_Catalogos_003TipoTurno(state, data) {
        state.SIAP_Catalogos_003TipoTurno[data.llave] = data.valor;
    },
    M_SIAP_Catalogos_027TipoContrato(state, data) {
        state.SIAP_Catalogos_027TipoContrato[data.llave] = data.valor;
    },
    M_SIAP_Catalogos_008TipoParentesco(state, data) {
        state.SIAP_Catalogos_008TipoParentesco[data.llave] = data.valor;
    },
    M_SIAP_DetalleEvaluacion_EvaluacionId(state, data) {
        state.SIAP_DetalleEvaluacion_EvaluacionId = data.id;
    },
    M_SIAP_Catalogos_032TipoEstatusIncidencias(state, data) {
        state.SIAP_Catalogos_032TipoEstatusIncidencias[data.llave]= data.valor;
    },
    M_SIAP_Catalogos_033TipoIncidencias(state, data) {
        state.SIAP_Catalogos_033TipoIncidencias[data.llave]= data.valor;
    },
    M_SIAP_Catalogos_037TipoPlantillaDeNombramiento: state => {
      return state.SIAP_Catalogos_037TipoPlantillaDeNombramiento;
    },
    M_SIAP_Catalogos_043TipoAsunto: state => {
      return state.SIAP_Catalogos_043TipoAsunto;
    }
}

let actions = {
    A_SIAP_Catalogo_Establecer041TipoEstadoCivil: ({ commit }, data) => {
        commit('M_SIAP_Catalogos_041TipoEstadoCivil', data)
    },
    A_SIAP_Catalogo_Establecer007TipoSexo: ({ commit }, data) => {
        commit('M_SIAP_Catalogos_007TipoSexo', data)
    },
    A_SIAP_Catalogo_Establecer007TipoNivelAcademico: ({ commit }, data) => {
        commit('M_SIAP_Catalogos_025TipoNivelAcademico', data)
    },
    A_SIAP_Catalogo_Establecer002TipoTitulo: ({ commit }, data) => {
        commit('M_SIAP_Catalogos_002TipoTitulo', data)
    },
    A_SIAP_Catalogo_Establecer024TipoDocumento: ({ commit }, data) => {
        commit('M_SIAP_Catalogos_024TipoDocumento', data)
    },
    A_SIAP_Catalogo_Establecer039TipoDepartamento: ({ commit }, data) => {
        commit('M_SIAP_Catalogos_039TipoDepartamento', data)
    },
    A_SIAP_Catalogo_Establecer006PuestoAdministrativo: ({ commit }, data) => {
        commit('M_SIAP_Catalogos_006PuestoAdministrativo', data)
    },
    A_SIAP_Catalogo_Establecer028TipoPlaza: ({ commit }, data) => {
        commit('M_SIAP_Catalogos_028TipoPlaza', data)
    },
    A_SIAP_Catalogo_Establecer022TipoMovimiento: ({ commit }, data) => {
        commit('M_SIAP_Catalogos_022TipoMovimiento', data)
    },
    A_SIAP_Catalogo_Establecer003TipoTurno: ({ commit }, data) => {
        commit('M_SIAP_Catalogos_003TipoTurno', data)
    },
    A_SIAP_Catalogo_Establecer027TipoContrato: ({ commit }, data) => {
        commit('M_SIAP_Catalogos_027TipoContrato', data)
    },
    A_SIAP_Catalogo_Establecer008TipoParentesco: ({ commit }, data) => {
        commit('M_SIAP_Catalogos_008TipoParentesco', data)
    },
    A_SIAP_Catalogo_Establecer032TipoEstatusIncidencias: ({commit}, data) => {
        commit('M_SIAP_Catalogos_032TipoEstatusIncidencias', data)
    },
    A_SIAP_Catalogo_Establecer033TipoIncidencias: ({commit}, data) => {
        commit('M_SIAP_Catalogos_033TipoIncidencias', data)
    },
    A_SIAP_Catalogo_Establecer034TipoSubIncidencias: ({commit}, data) => {
        commit('M_SIAP_Catalogos_034TipoSubIncidencias', data)
    },
    A_SIAP_Catalogo_Establecer037TipoPlantillaDeNombramiento: ({ commit}, data) => {
      commit('M_SIAP_Catalogos_037TipoPlantillaDeNombramiento', data)
    },
    A_SIAP_Catalogo_Establecer043TipoAsunto: ({commit}, data) => {
      commit('M_SIAP_Catalogos_043TipoAsunto', data)
    }
}

const SIAP = {
    State: state,
    Getters: getters,
    Mutations: mutations,
    Actions: actions
}
export default SIAP;



// WEBPACK FOOTER //
// ./src/store/SIAP.js